'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isValid = require('./selectors/isValid');

var _isValid2 = _interopRequireDefault(_isValid);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _isValid2.default)(_plain2.default);


// WEBPACK FOOTER //
// ./~/redux-form/lib/isValid.js